export default __webpack_public_path__ + "static/media/Stage3.132ee0c5.jpg";